import withEntity from '@/entity/components/with-entity';
import CurrentData from './current-data';

export default withEntity(CurrentData);
